/**
 * Which side of its trigger a DS Tooltip bubble goes on (STFFLG-4236).
 *
 * A side bubble (`left` / `right`) that runs past the edge of the viewport goes on the trigger's
 * other side when that has more room. A list's row tooltips sit beside the list this way, so their
 * bubble never covers the row above or below, and a list at the right edge of the page (a Select in
 * a right-anchored Drawer) puts them on its left instead of off screen. `top` and `bottom` keep
 * their side.
 */
import {getViewportBounds} from './dropdownPositioning'

export type TooltipSide = 'top' | 'bottom' | 'left' | 'right'

/** The side a shown bubble belongs on, from where it and its trigger are now. */
export function sideWithRoom(side: TooltipSide, trigger: DOMRect, bubble: DOMRect): TooltipSide {
  if (side !== 'left' && side !== 'right') return side
  const viewport = getViewportBounds()
  const roomLeft = trigger.left - viewport.left
  const roomRight = viewport.right - trigger.right
  if (side === 'right') {
    return bubble.right > viewport.right && roomLeft > roomRight ? 'left' : 'right'
  }
  return bubble.left < viewport.left && roomRight > roomLeft ? 'right' : 'left'
}
